import { inject, provide, type Component, type InjectionKey } from 'vue';
import type { BrandConfig } from './types';
import { glfConfig } from './glf/config';
import { comradeConfig } from './comrade/config';

const BRAND_KEY: InjectionKey<BrandConfig> = Symbol('brand');

const brands: Record<string, BrandConfig> = {
  glf: glfConfig,
  comrade: comradeConfig,
};

export function getBrandName(): string {
  return import.meta.env.VITE_BRAND || 'glf';
}

export function isComrade(): boolean {
  return getBrandName() === 'comrade';
}

export function getBrandConfig(): BrandConfig {
  return brands[getBrandName()] ?? glfConfig;
}

export function provideBrand() {
  const config = getBrandConfig();
  provide(BRAND_KEY, config);
  return config;
}

export function useBrand(): BrandConfig {
  const config = inject(BRAND_KEY);
  if (!config)
    throw new Error('Brand not provided. Call provideBrand() in App.vue');
  return config;
}

export function resolveComponent(
  name: string,
  defaultComponent: Component,
): Component {
  const config = inject(BRAND_KEY);
  return config?.componentOverrides?.[name] ?? defaultComponent;
}
